import React, { useState } from "react";
import {
  Drawer,
  IconButton,
  Typography,
  Tabs,
  Tab,
  Box,
  CircularProgress
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";

const NotificationComponent = ({ open, onClose }) => {
  const [selectedTab, setSelectedTab] = useState(0);

  const tabs = [
    { label: "Purchase Orders", count: 3 },
    { label: "Shipments", count: 12 },
    { label: "Asns", count: 5 },
    { label: "Nodes", count: 0 },
    { label: "Consolidations", count: 1 },
    { label: "Sales Orders", count: 1 }
  ];

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: '35%',
          backgroundColor: "#ffffff",
          boxShadow: "-4px 0px 12px rgba(0,0,0,0.1)"
        }
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        {/* HEADER */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            p: 1,
            borderBottom: "1px solid #e0e0e0",
            backgroundColor: "#ffffff"
          }}
        >
          <IconButton onClick={onClose} size="small" sx={{ mr: 1 }}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" sx={{ fontWeight: 600, color: "#333" }}>
            Notifications
          </Typography>
        </Box>

        {/* TABS CAROUSEL */}
        <Tabs
          value={selectedTab}
          onChange={(e, newValue) => setSelectedTab(newValue)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            backgroundColor: "#cad4c0ff",
            borderBottom: "1px solid #e0e0e0",
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 500,
              minHeight: 48
            },
            "& .Mui-selected": {
              color: "#4f4c4cff"
            },
            "& .MuiTabs-indicator": {
              backgroundColor: "#4f4c4cff",
              height: 3
            }
          }}
        >
          {tabs.map((tab) => (
            <Tab
              key={tab.label}
              label={
                <Box sx={{ display: "flex", alignItems: "center", color: "#515050ff" }}>
                  {tab.label}
                  <Box
                    sx={{
                      backgroundColor: "#878585ff",
                      color: "#fff",
                      borderRadius: "12px",
                      padding: "2px 8px",
                      fontSize: "12px",
                      fontWeight: 500,
                      ml: 1
                    }}
                  >
                    {tab.count}
                  </Box>
                </Box>
              }
            />
          ))}
        </Tabs>

        {/* SEARCH & FILTER ROW */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            p: 0.7,
            backgroundColor: "#ffffff",
            borderBottom: "1px solid #e0e0e0"
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flex: 1,
              backgroundColor: "#e5e2e2ff",
              borderRadius: "4px",
              px: 1
            }}
          >
            <SearchIcon sx={{ color: "#757575", mr: 1 }} />
            <input
              type="text"
              style={{
                flex: 1,
                border: "none",
                outline: "none",
                //background: "transparent",
                backgroundColor: "#e5e2e2ff",
                fontSize: "14px",
                height: "35px"
              }}
            />
          </Box>
          <IconButton sx={{ ml: 1 }}>
            <FilterListIcon sx={{ color: "#757575" }} />
          </IconButton>
        </Box>

        {/* CONTENT AREA */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#cad4c0ff"
          }}
        >
          <CircularProgress sx={{ color: "#ffffff" }} />
        </Box>
      </Box>
    </Drawer>
  );
};

export default NotificationComponent;